import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { Storage } from "../modules/Storage";
import { BASE_URL } from "./config";

// base URL과 엔드포인트들로 서비스 정의
// 엔드포인트는 query와 mutation으로 구분
// query는 GET, mutation은 POST로 요청
// query는 비동기로 처리되고, mutation은 동기로 처리
export const agentApi = createApi({
  reducerPath: "agentApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = Storage.get("authToken");
      if (token) {
        headers.set("X-AUTH-TOKEN", token);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getAgent: builder.query({
      query: (payload) => `/agent/${payload}`,
    }),
    getAgentInfo: builder.mutation({
      query: (payload) => `/agent/${payload}`,
    }),
    updateAgentInfo: builder.mutation({
      query: (payload) => ({
        url: `/agent`,
        method: "PUT",
        body: payload,
      }),
    }),
    uploadResumePDF: builder.mutation({
      query: (payload) => ({
        url: `/resume/upload`,
        method: "POST",
        body: payload,
      }),
    }),
    getPatentInfo: builder.query({
      query: ({agentNo, patentNo, humanName}) => {
        const pn = patentNo && patentNo.trim() !== "" ? patentNo : "KIPRIS";
        return `/attorney/getPatentInfo/${agentNo}/${humanName}/${pn}`;
      },
    }),
    getDesignInfo: builder.query({
      query: ({searchText}) => `/attorney/getDesignInfo/${searchText}`,
    }),
    getTradeMarkInfo: builder.query({
      query: ({searchText}) => `/attorney/getTradeMarkInfo/${searchText}`,
    }),
  }),
});

// 정의된 엔드포인트에서 자동으로 생성된 훅을 함수형 컴포넌트에서 사용하기 위해 export
export const { useGetAgentQuery, useGetAgentInfoMutation, useUpdateAgentInfoMutation, useUploadResumePDFMutation, useGetPatentInfoQuery, useGetDesignInfoQuery, useLazyGetDesignInfoQuery, useLazyGetPatentInfoQuery, useLazyGetTradeMarkInfoQuery } = agentApi;
